import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-pedido-finalizado',
  templateUrl: './pedido-finalizado.component.html',
  styleUrls: ['./pedido-finalizado.component.css']
})
export class PedidoFinalizadoComponent implements OnInit {

  config: any = {}
  constructor(
    private configService: ConfigService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.getConfig()
  }

  getConfig() {
    this.configService.config().subscribe(
      data => {
        this.config = data
        this.titleService.setTitle('Obrigado | ' + data.nome)
      }, err => {
      }
    )
  }

}
